import { render, staticRenderFns } from "./LPForm.vue?vue&type=template&id=61df6ffe"
import script from "./LPForm.vue?vue&type=script&lang=js"
export * from "./LPForm.vue?vue&type=script&lang=js"
import style0 from "./LPForm.vue?vue&type=style&index=0&id=61df6ffe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports